import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
    selector: 'app-line-list',
    templateUrl: './../../../templates/forms/modals/line-list.component.html',
})
export class LineListComponent implements OnInit {


    @Input()
    modalShow: boolean = true;


    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "LineNameListid"

    dataObj: any;
    lineList = [];
    searchFields: any[] = ['LINE_NAME', 'REMARKS'];
    public searchString;
    constructor(
        public langService: LangService,
        public gridService: GridService,
        private dataLoadService: DataLoadService) {
        this.colObj = [
            { headerName: langService.langData.lineName, field: 'LINE_NAME', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.remarks, field: 'REMARKS', sortable: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);
    
        this.dataLoadService.load('FG_HR_COMM_LINE', JSON.parse(JSON.stringify({P_COMPANY_NO: null}))).subscribe(result => {
            this.lineList =  result.body;
        })

    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}
